'use client';

import { eventListingSection } from '@stereoagency/sanity-schema';
import EventListingSection from './EventListingSection.client';

type Props = Omit<
  typeof eventListingSection.schema.eventListingSection,
  '_type'
> & {};

export default function DraftModeEventListingSection({
  enableTaxonomyFilter
}: Props) {
  return <EventListingSection enableTaxonomyFilter={enableTaxonomyFilter} />;
}
